import { withStyles } from '@material-ui/core/styles';
import { Button, Tooltip, IconButton, StepLabel } from '@material-ui/core';
import { Layers, FilterList, BarChart, Publish, ArrowDownward } from '@material-ui/icons';

export const FlatButton = withStyles({
    root: {
        boxShadow: 'none',
        padding: '8px 24px',
    },
    sizeLarge: {
        padding: '15px 24px',
    },
    contained: {
        '&:active': {
            boxShadow: 'none',
        }
    }
})(Button)

export const CustomTooltip = withStyles({
    tooltip: {
        maxWidth: 200,
    }
})(Tooltip)

const size = '3rem';

export const LayerIcon = withStyles({
    fontSizeLarge: {
        fontSize: size,
    }
})(Layers)

export const FilterIcon = withStyles({
    fontSizeLarge: {
        fontSize: size,
    }
})(FilterList)

export const ChartIcon = withStyles({
    fontSizeLarge: {
        fontSize: size,
    }
})(BarChart)

export const UploadIcon = withStyles({
    fontSizeLarge: {
        fontSize: size,
    }
})(Publish)

export const DownloadIcon = withStyles({
    fontSizeLarge: {
        fontSize: size,
    }
})(ArrowDownward)

export const CloseButton = withStyles({
    root: {
        padding: 8,
    }
})(IconButton)

export const NoLabel = withStyles({
    label: {
        display: 'none'
    }
})(StepLabel)